module.exports = __webpack_public_path__ + "static/eda_logo-84759d2a4bef8caa643fdd1198b4bb05.webp";